import { ICookieOptions, setCookie } from '@cian/utils/lib/browser/cookie';
// eslint-disable-next-line import/no-restricted-paths
import { getCookie } from '../../../../browser/utils/cookie';
import { MAP_PREVIEW_ONBOARDING_COOKIE_KEY } from '../../../constants/map';

export function getMapPreviewOnboardingCookie() {
  if (typeof window !== 'undefined') {
    const cookie = getCookie(MAP_PREVIEW_ONBOARDING_COOKIE_KEY);

    return Number(cookie) || 0;
  }

  return 0;
}

export function setMapPreviewOnboardingCookie(times: number) {
  const cookieConfig: ICookieOptions = { expires: 365 * 86400, secure: false };

  setCookie(MAP_PREVIEW_ONBOARDING_COOKIE_KEY, `${times}`, cookieConfig);
}
